import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const booleanComparisonUiNodeSpec: UiNodeSpec<'booleanComparison'> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'input1', 'input2' ],
    }),
    cfg: () => ({ controlValues: { operation: 'AND' }, id: getUID(), kind: 'booleanComparison', disabled: false }),
    controls: cfgFn => {
        const cfg = cfgFn();
        return {
            operation: {
                cfg: {
                    items: [
                        { label: 'AND', value: 'AND' },
                        { label: 'OR', value: 'OR' },
                        { label: 'XOR', value: 'XOR' },
                    ],
                    kind: 'selection',
                    label: 'Operation',
                },
                nodeCfg: cfg,
                value: cfg.controlValues.operation,
            },
        };
    },
    inputs: () => ({
        input1: {
            socket: 'boolean',
            label: 'Input 1',
        },
        input2: {
            socket: 'boolean',
            label: 'Input 2',
        },
    }),
    kindLabel: 'Boolean Comparison',
    nodeCategory: 'boolean',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
